import { createContext } from 'react';
import { FeatureCollection } from '../../util/to-feature-collection';

export interface LocationAnalyticsContextData {
    status: 'error' | 'success' | 'pending';
    featureCollection: FeatureCollection | null;
    progress: number;
    dateString: string | null;
    /** False when the whole filtered range predates the retention window. */
    isWithinDateRange: boolean;
    /** True when only part of the filtered range could be shown. */
    isDateRangeAdjusted: boolean;
    maxDaysAgoAllowed: number;
}

export const LocationAnalyticsContext = createContext<
    LocationAnalyticsContextData | undefined
>(undefined);
